import { useEffect, useRef } from 'react';
import {
    SIDE_PANEL_CLASS,
    SIDE_PANEL_SCROLLED_CLASS
} from '../HBSidePanel.consts';

export const useSidePanelBodyScroll = () => {
    const bodyContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = bodyContainerRef.current;
        if (!container) {
            return;
        }
        const panel = container.closest(`.${SIDE_PANEL_CLASS}`);
        if (!panel) {
            return;
        }
        const onScroll = () => {
            if (container.scrollTop > 0) {
                panel.classList.add(SIDE_PANEL_SCROLLED_CLASS);
            } else {
                panel.classList.remove(SIDE_PANEL_SCROLLED_CLASS);
            }
        };
        onScroll();
        container.addEventListener('scroll', onScroll, { passive: true });
        return () => container.removeEventListener('scroll', onScroll);
    }, []);

    return { bodyContainerRef };
};
